import { STG, STG_ENV } from './stg-env'

// The end-to-end development environment
export const ENVIRONMENT_DEV = 'dev'
// Deprecated
export const ENVIRONMENT_TEST = 'test'
// Deprecated
export const ENVIRONMENT_QA = 'qa'
// Deprecated
export const ENVIRONMENT_DEMO = 'demo'
// Used during release to validate enrollme before push to production (uses prod backend)
export const ENVIRONMENT_STAGE = 'stage'
// `stg` - The end-to-end staging environment
export const ENVIRONMENT_STG = STG
// production
export const ENVIRONMENT_PROD = 'prod'

export const ENVIRONMENT_PREFIX_DEV = 'dev-'
export const ENVIRONMENT_PREFIX_TEST = 'test-'
export const ENVIRONMENT_PREFIX_QA= 'qa-'
export const ENVIRONMENT_PREFIX_DEMO = 'demo-'
export const ENVIRONMENT_PREFIX_STAGE = 'stage-'
export const ENVIRONMENT_PREFIX_STG = `${STG}-`

const { hostname } = window.location
let environment = 'prod'

// localhost and dev-hostname result in a dev environment. hostname.stage will be stage environment
// ie: localhost:3000 or dev-app.hixme.com will be dev
// ie: stage-app.hixme.com will be stage
// ie: enrollme.stg.surecolabs.com will be stg (a new, isolated staging tier)
// default is prod
export function setEnvironmentWithHostname(useHostname = hostname) {
  environment = ENVIRONMENT_PROD
  if (new RegExp(`\\.${ENVIRONMENT_STG}(\\.|$)`).test(useHostname)) {
    environment = ENVIRONMENT_STG
  } else if (
    useHostname === 'localhost' ||
    useHostname.indexOf(ENVIRONMENT_PREFIX_DEV) !== -1 ||
    useHostname.indexOf(ENVIRONMENT_DEV) !== -1 ||
    useHostname.indexOf('192.168') !== -1
  ) {
    environment = ENVIRONMENT_DEV
  } else if (useHostname.indexOf(ENVIRONMENT_PREFIX_TEST) !== -1) {
    environment = ENVIRONMENT_TEST
  } else if (useHostname.indexOf(ENVIRONMENT_PREFIX_DEMO) !== -1) {
    environment = ENVIRONMENT_DEMO
  } else if (useHostname.indexOf(ENVIRONMENT_PREFIX_STAGE) !== -1) {
    environment = ENVIRONMENT_STAGE
  } else if (
    useHostname.startsWith(ENVIRONMENT_PREFIX_QA) ||
    useHostname.includes(`.${ENVIRONMENT_QA}`)
  ) {
    environment = ENVIRONMENT_QA
  }
}

setEnvironmentWithHostname()

// helper functions
// Here dev and test are considered development environments
// Prod and demo are considered production level environments
export const isDevelopment = () =>
  environment === ENVIRONMENT_DEV ||
  environment === ENVIRONMENT_TEST ||
  environment === ENVIRONMENT_QA
export const isStaging = () => environment === ENVIRONMENT_STAGE
export const isStg = () => environment === ENVIRONMENT_STG
export const isTesting = () => environment === ENVIRONMENT_TEST
export const isDemo = () => environment === ENVIRONMENT_DEMO
export const isProduction = () =>
  environment === ENVIRONMENT_PROD ||
  environment === ENVIRONMENT_DEMO ||
  environment === ENVIRONMENT_STAGE

export const getEnvironment = () => environment

// prefix used for url building, to keep testing consistent
// link from dev-admin.hixme.com can link to dev-enrollme.hixme.com
export const getEnvironmentPrefix = () => {
  if (environment === ENVIRONMENT_STG) {
    return ENVIRONMENT_PREFIX_STG
  } else if (environment === ENVIRONMENT_DEV) {
    return ENVIRONMENT_PREFIX_DEV
  } else if (environment === ENVIRONMENT_TEST) {
    return ENVIRONMENT_PREFIX_TEST
  } else if (environment === ENVIRONMENT_DEMO) {
    return ENVIRONMENT_PREFIX_DEMO
  } else if (environment === ENVIRONMENT_STAGE) {
    return ENVIRONMENT_PREFIX_STAGE
  } else if (environment === ENVIRONMENT_QA) {
    return ENVIRONMENT_PREFIX_QA
  }

  // production doesn't require a prefix
  return ''
}

export const getLaunchDarklyConfig = () => {
  const LAUNCH_DARKLY_CONFIG_MAP = {
    dev: {
      clientSideID: '647e5a2d23dfee131a3e5c5c',
    },
    qa: {
      clientSideID: '6479137cbbaef41373c01c8f',
    },
    uat: {
      clientSideID: '647e5a3495a60913574bc456',
    },
    stage: {
      clientSideID: '647e5a3b2257ff133b1d1b24',
    },
    stg: {
      clientSideID: STG_ENV.launchDarklyClientSideId,
    },
    prod: {
      clientSideID: '6479137cbbaef41373c01c90',
    },
  }

  return LAUNCH_DARKLY_CONFIG_MAP[environment]
}

export default {
  isDevelopment,
  isStaging,
  isStg,
  isTesting,
  isDemo,
  isProduction,
  getEnvironment,
  getEnvironmentPrefix,
  getLaunchDarklyConfig,
  setEnvironmentWithHostname,
}
